<div class="row white rounded justify-content-center shadow-sm m-0 p-0">
    <div class="col-12 col-md-9 py-5 m-0 p-0">
        <mat-accordion>
          <ng-container *ngFor="let question of questions">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="pb-0">
                  <b>
                    {{ question?.Question }}
                  </b>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="p-0 m-0">{{ question?.Answer }}</p>
            </mat-expansion-panel>
          </ng-container>
          </mat-accordion>
    </div>
</div>